import * as Type from './actionsTypes';

const loadModuleConfiguration = (callback) => ({
  type: Type.FETCH_MODULE_CONFIGURATION,
  callback,
});

export {
  loadModuleConfiguration,
};
